<template>
  <div class="product pmt" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">Polskie Mosty Technologiczne USA</div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Polish Technology Bridge to USA</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
           Projekt Polskie Mosty Technologiczne ma na celu wspieranie polskich firm w procesie internacjonalizacji. Projekt organizowany jest przez Polską Agencję Inwestycji i Handlu.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
Celem projektu jest ekspansja na rynek amerykański. Trzeba pamiętać, że USA jest wiodącym krajem, jeśli chodzi o energetykę wiatrową. W ramach etapu krajowego tego projektu wypracowaliśmy strategię ekspansji, którą będziemy konsekwentnie wdrażać w etapie zagranicznym, trwającym do sierpnia 2021. Celem projektu Bioseco jest wybór najatrakcyjniejszego lokalnego rynku na terenie Stanów Zjednoczonych i rozpoznanie wymogów regulacyjnych pozwalających na sprzedaż Bird Protection System. W konsekwencji naszym nadrzędnym celem jest nawiązanie współpracy handlowej z podmiotami w USA.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
Projekt Polskie Mosty Technologiczne współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach III Osi priorytetowej - Wsparcie innowacji w przedsiębiorstwach; Działanie: 3.3. Wsparcie promocji oraz internacjonalizacji innowacyjnych przedsiębiorstw, Programu Operacyjnego Inteligentny Rozwój 2014-2020. Nr umowy: POIR-03.03.01-00-0001/17-00.
                <br/><br />
                  Dofinansowanie projektu przez PAIH:<br/>200.000,00 PLN
                </span>
              </li>

            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
             Project PMT („Polskie Mosty Technologiczne”) aims to support Polish companies in the process of internationalization. The project is organized by the Polish Investment and Trade Agency.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  The aim of the project is expansion to the American market. The USA is the leading country in wind energy. As part of the first stage, we have developed an expansion strategy, which we will consistently implement in the second stage, lasting until August 2021. During the project Bioseco aims to select the most attractive market in the United States and to identify regulatory requirements allowing the sale of the Bird Protection System. Consequently, our main goal is to establish commercial cooperation with entities in the USA.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
The project PMT (Polskie Mosty Technologiczne) is co-financed from the European Regional Development Fund, under the Priority 3 - Support for innovation in enterprises; Measure: 3.3. Support for the promotion and internationalization of innovative enterprises, the Intelligent Development Operational Program 2014-2020. Agreement number: POIR-03.03.01-00-0001/17-00.
               <br /><br/>
                  Amount of founding from UE:<br/>
200.000.00 PLN
                </span>
              </li>



            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      isPageContrasted() {
        return store.state.isPageContrasted
      },
      isFontBigger() {
        return store.state.isPageFontBigger
      },
      smoothScroll: () => smoothScroll
    },

    methods: {},
    mounted: function () {
      store.state.isAccessibilityVisible = true;
      store.state.showPAIH = true;
    },
    destroyed: function () {
      store.state.isAccessibilityVisible = false;
      store.state.showPAIH = false;
    },
  }
</script>

<style>


  .product.pmt .page-header {
    background: url(/static/img/product/header-area.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
    min-height: 100px;
    padding-bottom: 60px;
  }

  .bps header.page-header .heading-text {
    max-width: 600px;
  }

  .product .why-us-solution .elements .element.bps .text-box {
    float: left;
    max-width: initial;
    margin-top: 20px;
    margin-bottom: 100px;
  }

  .product .why-us-solution .elements .element.bps .text-box ul li .text {
    margin-top: -20px;
  }


  .ue {
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ue img {
    max-width: 940px;
    width: 35%;
  }

  .product.pmt .ue img {
    max-width: 940px;
    width: 50%;
  }

  .product.contrasted {
    background: #000;
    color: yellow;
  }

  .product.contrasted .heading-text {
    color: yellow;
  }

  .product.contrasted .ue {
    background: #000;
  }

  .product.contrasted header a {
    color: yellow;
    background: #000;
  }

  .product.contrasted .btn {
    color: yellow;
    background: #000;
  }

  .product.fontBigger .why-us-solution .elements .element .text-box ul li .text {
    font-size: 1.6em;
    line-height: 1.6em;
  }


</style>



// WEBPACK FOOTER //
// PMT.vue?3a5d4b46